import { AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
  ICartRequestData,
  ICartResponse,
  IGetCartResponse,
} from '../../types/api/cart.d'
import { isBrowser } from '../../utils/isBrowser'
import { publicRequest } from './publicRequest'

export const addToCart = async (
  id: string | number,
  data: ICartRequestData
): Promise<ICartResponse> => {
  const response: AxiosResponse<ICartResponse, AxiosRequestConfig> =
    await publicRequest.post(
      `v1/event/${id}/add-to-cart/`,
      { data },
      {
        headers: {
          ...publicRequest.defaults.headers.common,
          'Referer-Url': isBrowser && typeof document !== 'undefined' ? document.referrer : '',
        },
      }
    )
  return response.data
}

export const getCart = async (): Promise<IGetCartResponse> => {
  const response: AxiosResponse<IGetCartResponse, AxiosRequestConfig> =
    await publicRequest.get(`v1/cart`)
  return response.data
}
